<div class="container">
  <div class="logout-container">
    <img src="./assets/shell/logout.svg" width="250" height="250" alt="" /> <br />
    <span class="logout-title">{{ 'general.gen_title_logout_page' | translate }}</span
    ><br />
    <div class="logout-text">
      {{ 'general.gen_msg_logout_page' | translate }}<br />
      <a routerLink="/" class="logout-link">{{
        'general.gen_msg_connect_logout_page' | translate
      }}</a>
      {{ 'general.gen_msg_again_logout_page' | translate }}
    </div>
  </div>
</div>
